/* file description */

import { EsConfigType } from '@/asset/AssetTask/templates/Cascade/effect';
import useMetaStore from '@/store/useMetaStore';

export const useResultEventConfig = (field: any) => {
  const { events, emitEvent, pageType, pageConfig } = useMetaStore();

  let es: EsConfigType[] = [];
  if (pageType === 'add' || pageType === 'edit') {
    es = pageConfig?.createPageConfig?.eventList || [];
  }
  if (pageType === 'view') {
    es = pageConfig?.detailPageConfig?.eventList || [];
  }
  if (pageType === 'list') {
    es = pageConfig?.listPageConfig?.eventList || [];
  }
  const clickEvent = events?.current?.filter((item) => item.touchConfig === 'click') || [];
  const clickSingalEvent = clickEvent.find((e) => (e.moduleName === field.moduleName && e.fieldName === field.name));

  let resultEventConfig;
  if (clickSingalEvent) {
    resultEventConfig = es.find((e) => e.code === clickSingalEvent?.code);
  }

  return {
    resultEventConfig,
  };
};
